import { Box, FormControlLabel, Switch } from "@mui/material";
import { useState } from "react";
import UpgradeDialogV2 from "../Dialogs/UpgradeDialogV2";

const linkTreeUpgradeDialog = {
    title: "Unlock Link Trees",
    subtitle: "Create powerful landing pages, collect leads, and personalize your QR code experience.",
    features: [
      {
        primary: "Create Beautiful Link Trees",
        secondary: "Showcase multiple links in a single QR code and direct users to your key destinations."
      },
      {
        primary: "Custom Forms for Lead Collection",
        secondary: "Capture emails, phone numbers, and feedback directly through QR-scanned forms."
      },
      {
        primary: "Full Branding & Customization",
        secondary: "Design your link tree and forms with brand colors, logos, and unique layouts."
      },
      {
        primary: "Advanced Analytics & Insights",
        secondary: "Track user interactions, clicks, and form submissions in real-time."
      },
      {
        primary: "Dynamic Updates Without Reprinting",
        secondary: "Change links, update form fields, or modify content anytime—no need to reprint QR codes."
      },
      {
        primary: "Seamless Integration & API Access",
        secondary: "Connect your forms to CRM tools, email marketing platforms, and automation workflows."
      }
    ]
  };
  

  interface Props {
    show: boolean,
    hide:() => void
  }
  
  
const LinkTreeTeaser = ({ show, hide }: Props) => {
    return(
        <>
            <UpgradeDialogV2 
                open={show} 
                onClose={hide} 
                title={linkTreeUpgradeDialog.title}
                subtitle={linkTreeUpgradeDialog.subtitle}
                requestedFeature="linktree"
            />

        </>
    )
}

export default LinkTreeTeaser;